module.exports = __webpack_public_path__ + "static/img/14010214.1cfe73e8.png";